import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import React, { useState, useEffect } from "react";
import "./Css/View.css";
import API_BASE from "../config/api";

const ExamEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(true);

  const [paper, setPaper] = useState({
    softwareId: "",
    paperType: "",
    standardId: "",
    subjectId: "",
    paperDate: "",
    paperStartTime: "",
    paperEndTime: "",
    marks: "",
    answerSelectionType: "",
    paperSupervisor: "",
    instruction: ""
  });

  const [dropdowns, setDropdowns] = useState({
    softwares: [],
    standards: [],
    subjects: []
  });

  /* ---------------- LOAD PAPER ---------------- */
  const loadPaper = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/Papers/${id}`, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("accessToken")}` }
      });

      const p = res.data;
      console.log(res.data, 'paper')

      setPaper({
        softwareId: p.softwareId,
        paperType:
          p.paperType === "UnitTest" ? 1 :
            p.paperType === "MidSem" ? 2 :
              p.paperType === "EndSem" ? 3 : "",
        standardId: p.standardId,
        subjectId: p.subjectId || "",
        paperDate: p.paperDate?.split("T")[0],
        paperStartTime: p.paperStartTime?.substring(0, 5),
        paperEndTime: p.paperEndTime?.substring(0, 5),
        marks: p.marks,
        answerSelectionType: p.answerSelectionType,
        paperSupervisor: p.paperSupervisor,
        instruction: p.instruction
      });

      loadDropdowns(p.softwareId, p.standardId);
    } catch (err) {
      console.error(err);
      alert("Failed to load paper");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- DROPDOWNS ---------------- */
  const loadDropdowns = async (softwareId, standardId) => {
    const res = await axios.get(
      `${API_BASE}/api/Papers/dropdowns?softwareId=${softwareId || ""}&standardId=${standardId || ""}`
      , {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("accessToken")}` }
      }
    );
    setDropdowns(res.data);
    console.log(res.data, 'dropdown')
  };

  useEffect(() => {
    loadPaper();
  }, [id]);

  /* ---------------- HANDLE CHANGE ---------------- */
  const handleChange = e => {
    const { name, value } = e.target;

    setPaper(prev => ({
      ...prev,
      [name]: ["softwareId", "standardId", "subjectId"].includes(name)
        ? Number(value)
        : value
    }));

    if (name === "softwareId") loadDropdowns(value, null);
    if (name === "standardId") loadDropdowns(paper.softwareId, value);
  };

  /* ---------------- SAVE ---------------- */
  const handleSave = async () => {
    try {

      const formatTime = t => {
        if (!t) return "00:00:00";
        return t.length === 5 ? t + ":00" : t;
      };

      const payload = {
        paperType: Number(paper.paperType),
        paperDate: paper.paperDate,
        paperStartTime: formatTime(paper.paperStartTime),
        paperEndTime: formatTime(paper.paperEndTime),
        marks: Number(paper.marks),
        answerSelectionType: Number(paper.answerSelectionType),
        paperSupervisor: paper.paperSupervisor,
        instruction: paper.instruction
      };

      await axios.put(
        `${API_BASE}/api/Papers/${id}`,
        payload,
        { headers: { Authorization: `Bearer ${sessionStorage.getItem("accessToken")}` } }
      );

      alert("Paper updated successfully");
      navigate("/dashboard/exammanagment");

    } catch (err) {
      console.log(err.response?.data);
      alert(JSON.stringify(err.response?.data?.errors || "Update failed"));
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="student-page">

      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          परीक्षा व्यवस्थापन &gt;&gt; <span>परीक्षा संपादन करा</span>
        </h3>

        <div className="edit-btnn">
          <button className="btn outlinee" onClick={() => navigate(-1)}>रद्द करा</button>
          <button className="btn primaryy" onClick={handleSave}>सेव्ह करा</button>
        </div>
      </div>

      <h2>परीक्षा संपादन करा</h2>

      <div className="info-gridd">

        {/* SOFTWARE */}
        <div className="info-boxx">
          <label>परीक्षेचे नाव</label>
          <select name="softwareId" value={paper.softwareId} onChange={handleChange}>
            {dropdowns.softwares.map(x =>
              <option key={x.id} value={x.id}>{x.name}</option>
            )}
          </select>
        </div>

        {/* PAPER TYPE */}
        <div className="info-boxx">
          <label>परीक्षा प्रकार</label>
          <input name="paperType" value={paper.paperType} onChange={handleChange} />
        </div>

        {/* STANDARD */}
        <div className="info-boxx">
          <label>इयत्ता</label>
          <select name="standardId" value={paper.standardId} onChange={handleChange}>
            {dropdowns.standards.map(x =>
              <option key={x.id} value={x.id}>{x.name}</option>
            )}
          </select>
        </div>

        {/* SUBJECT */}
        <div className="info-boxx">
          <label>विषय नियुक्त करा</label>
          <select name="subjectId" value={paper.subjectId} onChange={handleChange}>
            <option value="">-- विषय निवडा --</option>
            {dropdowns.subjects.map(x =>
              <option key={x.id} value={x.id}>{x.name}</option>
            )}
          </select>
        </div>

        {/* DATE */}
        <div className="info-boxx">
          <label>परीक्षेची तारीख</label>
          <input type="date" name="paperDate" value={paper.paperDate} onChange={handleChange} />
        </div>

        {/* START TIME */}
        <div className="info-boxx">
          <label>परीक्षेची सुरूवातीची वेळ</label>
          <input type="time" name="paperStartTime" value={paper.paperStartTime} onChange={handleChange} />
        </div>

        {/* END TIME */}
        <div className="info-boxx">
          <label>परीक्षेची समाप्तीची वेळ</label>
          <input type="time" name="paperEndTime" value={paper.paperEndTime} onChange={handleChange} />
        </div>

        {/* MARKS */}
        <div className="info-boxx">
          <label>गुण</label>
          <input name="marks" value={paper.marks} onChange={handleChange} />
        </div>

        {/* ANSWER TYPE */}
        <div className="info-boxx">
          <label>उत्तर निवड प्रकार</label>
          <input name="answerSelectionType" value={paper.answerSelectionType} onChange={handleChange} />
        </div>

        {/* SUPERVISOR */}
        <div className="info-boxx">
          <label>नियुक्त शिक्षक</label>
          <input name="paperSupervisor" value={paper.paperSupervisor} onChange={handleChange} />
        </div>

        {/* INSTRUCTION */}
        <div className="info-boxx">
          <label>सूचना</label>
          <textarea name="instruction" value={paper.instruction} onChange={handleChange} />
        </div>

      </div>
    </div>
  );
};

export default ExamEdit;
